module.exports = __webpack_public_path__ + "static/stars-4c2da85069ff33ce701a4ab9c9719f4e.jpg";